module.exports = __webpack_public_path__ + "img/ProfilePage.e7e17a46.png";